import { Redo } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import { useState } from 'react';
import useEventListener from '~/hooks/useEventListener';
import useViewportEnvironment from '~/hooks/useViewportEnvironment';

type RedoContouringButtonProps = {
    disabled?: boolean;
};

const RedoContouringButton = ({ disabled }: RedoContouringButtonProps) => {
    const { environment } = useViewportEnvironment();
    const redoContouring = () => {
        environment?.redoContouring();
    };

    const [canRedo, setCanRedo] = useState(false);

    const handleStructureSetChange = () => {
        setCanRedo(environment?.canRedoContouring() ?? false);
    };

    useEventListener(
        'structure_set_property_changed',
        handleStructureSetChange,
        environment?.eventTarget
    );

    return (
        <Button
            size="small"
            value="redo-contouring"
            onClick={() => {
                redoContouring();
            }}
            disabled={!canRedo || disabled}
        >
            <Tooltip title="Redo contour">
                <Redo />
            </Tooltip>
        </Button>
    );
};

export default RedoContouringButton;
